import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'  // 导入国际化配置
import { loadTheme, getThemeImage } from '@/utils/theme'
import themeMixin from '@/mixins/theme'

// import Toast from './components/Toast'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import http from "@/utils/api";
Vue.prototype.$http = http;

// 主题：默认加载经典金
const defaultTheme = loadTheme();
store.dispatch('theme/applyTheme', defaultTheme.id);

Vue.prototype.$themeImg = getThemeImage;
Vue.mixin(themeMixin);

// 定义插件对象
// const ToastObj = {
//   install: function (Vue) {
//     // 创建一个Vue的“子类”组件
//     const ToastConstructor = Vue.extend(Toast)
//     // 创建一个该子类的实例,并挂载到一个元素上
//     const instance = new ToastConstructor()
//     console.log(instance)
//     // 将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
//     instance.$mount(document.createElement('div'))
//     document.body.appendChild(instance.$el)
//
//     // 在Vue的原型链上注册方法，控制组件
//     Vue.prototype.$toast = (msg, duration = 1500) => {
//       instance.message = msg
//       instance.visible = true
//       setTimeout(() => {
//         instance.visible = false
//       }, duration)
//     }
//
//
//     // 在Vue的原型链上注册方法，控制组件
//     Vue.prototype.$hideToast = () => {
//       instance.visible = false
//     }
//   }
// }
// Vue.use(ToastObj)

Vue.config.productionTip = false

const vueInstance = new Vue({
  store,
  router,
  i18n,  // 注入 i18n 实例
  render: h => h(App)
}).$mount('#app')

export default vueInstance;